// src/components/CreateIdealCandidateForm/IdealCandidateProfileView.js
import React from 'react';
import { Paper, Box, Grid, Typography, Divider, Chip, Stack, useTheme, alpha } from "@mui/material";
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';

const Section = ({ icon, title, children }) => (
  <Box>
    <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
      {icon}
      <Typography variant="h6" fontWeight={500}>{title}</Typography>
    </Stack>
    {children}
  </Box>
);

export default function IdealCandidateProfileView({ data, accentColor }) {
  const theme = useTheme();

  return (
    <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, borderRadius: '20px', bgcolor: 'background.paper', maxWidth: '1200px', mx: 'auto' }}>
      <Box sx={{ pb: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h4" fontWeight={600} gutterBottom sx={{ overflowWrap: 'break-word' }}>
            {data.title || "N/A"}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>
          {data.description || "No description provided."}
        </Typography>
      </Box>
      <Grid container spacing={4} sx={{ mt: 1 }}>
        <Grid item xs={12} md={6}>
          <Section icon={<HandymanOutlinedIcon sx={{ color: accentColor }} />} title="Key Skills">
            <Stack spacing={1}>
              {data.skills?.filter(s => s.name).map((skill, i) => (
                <Paper key={i} variant="outlined" sx={{ p: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '12px' }}>
                  <Typography sx={{ overflowWrap: 'break-word', mr: 1 }}>{skill.name}</Typography>
                  <Chip label={`Weight: ${skill.weight}`} sx={{ bgcolor: alpha(accentColor, 0.9), color: '#fff', flexShrink: 0 }} />
                </Paper>
              ))}
            </Stack>
          </Section>
        </Grid>
        <Grid item xs={12} md={6}>
          <Section icon={<AccountTreeOutlinedIcon sx={{ color: accentColor }} />} title="Core Behaviors">
            <Stack spacing={1}>
              {data.behaviors?.filter(b => b.name).map((behavior, i) => (
                <Paper key={i} variant="outlined" sx={{ p: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '12px' }}>
                  <Typography sx={{ overflowWrap: 'break-word', mr: 1 }}>{behavior.name}</Typography>
                  <Chip label={`Weight: ${behavior.weight}`} sx={{ bgcolor: alpha(accentColor, 0.9), color: '#fff', flexShrink: 0 }} />
                </Paper>
              ))}
            </Stack>
          </Section>
        </Grid>
      </Grid>
    </Paper>
  );
};
